
import {ref, computed} from 'vue';
import {injectEnv} from "@fd/Environment";

export function useAutocomplete(props, emit, afterSelectResult, nothingFound) {
	
	const results = ref<SuggestResult[]>([]);
	const selected = ref(1);
	const errorMessage = ref("");
	const progress = ref(false);
	const inputValue = ref(props.value);
	const suggestedKey = ref("");//hold copy of suggested key value
	const env = injectEnv();
	
	const isError = computed(() => {
		return  errorMessage.value !== null && errorMessage.value !== undefined && errorMessage.value.length>0;
	});
	
	const pickMode = computed(() => {
		return props.mode === "pick";
	});
	
	const pickSelected = computed(() => {
		return Boolean(pickMode.value && suggestedKey.value && suggestedKey.value.length>0);
	});
	
	
	function sendData(canSendData: boolean): void {
		if (canSendData) {
		progress.value=true;
		selected.value=-1;
		errorMessage.value=null;
		let suggest = {"phrase":inputValue.value, "params": props.params};
		//console.log("send to:"+props.restApi+" : "+JSON.stringify(suggest));
		env.net.fetch(props.restApi,"POST", suggest)
				.then(response => response.json())
				.then(data => {
					//console.log("get:"+JSON.stringify(data));
					errorMessage.value=data.error;
					if (data.ok) {
						results.value=data.results;
					}
					progress.value=false;
				})
				.catch((error) => {
					console.log("Error sending form:"+error.message);
					errorMessage.value=error.message;
					progress.value=false;
				});
		}
		else {
			results.value=[];
		}
	}

	function selectResult(result: SuggestResult): void {
		if (props.mode==="folder") {
			inputValue.value = result.value+"/";
		}
		else if (props.mode==="login") {
			inputValue.value = "@"+result.key;
		}
		else {
			inputValue.value = result.value;
		}
		//console.log("emit: modelValue:"+props.modelValue+" ->"+result.key);
		suggestedKey.value=result.key;
		emit('update:modelValue', suggestedKey.value);
		emit('updateInputValue', inputValue.value);
		afterSelectResult(result);
		resetResults();
		errorMessage.value=null;

	}

	function selectSelectedResult(): void {
		if (selected.value<0 && results.value.length>0) { //on enter select first seggest things
			selected.value=0;
		}

		if (selected.value>-1) {
			let value = results.value[selected.value];
			selectResult(value);
		}
		else { // update 0
			emit('update:modelValue', "");
			emit('updateInputValue', inputValue.value);
			afterSelectResult(null);
		}
	}
	
	function resetValue(): void {
		inputValue.value="";
		suggestedKey.value="";
		emit('update:modelValue', "");
		emit('updateInputValue', inputValue.value);
	}

	function resetResults(): void {
		results.value=[];
		selected.value=-1;
	}

	function setSelected(index: number): void {
		selected.value=index;
	}

	function goUp(): void {
		if (selected.value>0) {
			selected.value--;
		}
	}

	function goDown(): void {
		if (results.value.length>(selected.value+1)) {
			selected.value++;
		}
	}

	function focusOut(): void {
		if (props.mode==="folder" && inputValue.value) {
			if (!inputValue.value.startsWith("/")) {
				inputValue.value = "/"+inputValue.value;
			}
			if (inputValue.value.endsWith("/")) {
				inputValue.value = inputValue.value.slice(0,-1);
			}
		}
		else if (pickMode.value && !suggestedKey.value) {
			//try found result or empty value
			var found = findResult(inputValue.value);
			if (found) {
				selectResult(found);
			}
			else {//empty input
				inputValue.value="";
			}
		}

		emit('updateInputValue', inputValue.value);
		setTimeout(resetResults, 300);
	}
	
	function findResult(value: string): SuggestResult {
		return results.value.find(item=>item.key===value || item.value===value);
	}
	
	
	return  {	results, selected, errorMessage, isError,
				progress, inputValue, resetValue, suggestedKey,
				sendData, selectResult, selectSelectedResult,  
				setSelected, goUp, goDown, focusOut, pickSelected };
}


export interface SuggestResult {
	key: string;
	value: string;
	spec?: string;
	icon?: string;
}